import React from 'react'
import {
  NotificationBodyWithAccessCard,
  NotificationViewModel,
} from '../../../..'
import NotificationAutoInterUpdator from '../../../../NotificationAutoInterUpdator'
import i18next from 'i18next'

const NewElementRemoved = (props) => {
  const { sender } = props
  NotificationAutoInterUpdator(props)
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={''}
      notificationBody={
        <NotificationBodyWithAccessCard
          {...props}
          notificationBodyContent={
            rtl
              ? `قام ${sender?.name}  بحذف عنصر من قناة انت مشارك بها`
              : `${sender?.name} removed an element to a channel you are in`
          }
        />
      }
      buttonsArray={[]}
    />
  )
}

export default NewElementRemoved
